import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

const initialState = {
    user: {
        data: {},
        isSign: false,
        loading: true,
        isSigning: false,
        role: ""
    },
    tasks: {
        data: [],
        loading: false,
        clientSelected: {},
        dateFilter: 0,
        snapshot: {}
    },
    stock: {
        data: [],
        loading: false
    },
    clients: {
        data: [],
        loading: false,
        cli: "cli"
    },
    invoices: {
        data: [],
        loading: false
    },
    tickets: {
        data: [],
        loading: false
    },
    taskSelected: {
        data: {},
        detail: {
            observations: [],
            images: [],
            signature: {}
        },
        loading: false
    },
    notes: {
        data: {},
        loading: false
    },
    reacondicionados: {
        data: [],
        loading: false
    }
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(reducers, initialState, composeEnhancers(applyMiddleware(thunk)));